import { useQuery } from 'react-query';

import { useApi } from '@/lib/api';
import { computeGeometryAreaIdOrStageId } from '@/lib/api/queries/utils';
import { useLocale } from '@/lib/contexts';

import { TypePeriod } from '@/components/activity-reports/period-selector';

interface ActivityReportUnitCategoryProps {
  workspaceId: string;
  geometry?: string;
  areaId?: string;
  filters?: Record<string, any>;
  classification: string;
  period?: TypePeriod[];
  lastPeriodIncludes?: string;
  enabled?: boolean;
}

export function useArListedNewbuildsUnitMixContainedTable({
  workspaceId,
  filters,
  geometry,
  classification,
  areaId,
  period,
  lastPeriodIncludes,
  enabled,
}: ActivityReportUnitCategoryProps) {
  const { api } = useApi();
  const { locale } = useLocale();

  return useQuery(
    [
      'activity-reports-listed-newbuilds-unit-mix-contained-table',
      workspaceId,
      locale,
      filters,
      geometry,
      classification,
      areaId,
      period,
      enabled,
      lastPeriodIncludes,
    ],
    async () =>
      typeof workspaceId === 'string'
        ? api.geodata.chartSources.activityReportsListedNewbuildsUnitMixContainedTable(
            workspaceId,
            {
              ...filters,
              ...computeGeometryAreaIdOrStageId(geometry, areaId),
              classification: classification,
              period: period,
              last_period_includes: lastPeriodIncludes,
            }
          )
        : undefined,
    {
      enabled:
        enabled &&
        !!workspaceId &&
        !!period &&
        !!computeGeometryAreaIdOrStageId(geometry, areaId),
      //These are mandatory params by the endpoint
    }
  );
}
